// nationalities.ts — getipptes Datenmodul + reine Filterfunktion über die
// vollständige Nationalitäten-Liste (nationalities.json, nach deutschem
// Ländernamen sortiert). Wird von NationalitySelect (Anlage + ContactDetails)
// genutzt und ist unit-testbar (siehe nationalities.test.ts).

import nationalitiesJson from "./nationalities.json";

export interface Nationality {
  /** ISO 3166-1 alpha-2 (für das Flaggen-Icon). */
  code: string;
  /** Deutsches Adjektiv, z. B. „Deutsch" (der gespeicherte Wert). */
  adjective: string;
  /** Deutscher Ländername, z. B. „Deutschland" (Hinweis + Suche). */
  country: string;
}

export const NATIONALITIES = nationalitiesJson as Nationality[];

/** Default-Staatsangehörigkeit der Anlage. */
export const DEFAULT_NATIONALITY = "Deutsch";

/** Default-Land einer Anschrift (CountrySelect). */
export const DEFAULT_COUNTRY = "Deutschland";

const norm = (s: string) =>
  s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

/**
 * Alle Nationalitäten, deren Adjektiv ODER Ländername den (diakritik-insensitiven)
 * Suchbegriff enthält. Leerer Begriff → die VOLLE Liste (kein Cap!) — damit die
 * Auswahl über „Gambisch" hinaus scroll-/wählbar bleibt. Der frühere Cutoff bei
 * „Gambisch" war kein Datenfehler, sondern ein Render-Limit (SearchableSelect
 * `maxResults=50`, Gambia = 50. Eintrag der ländersortierten Liste).
 */
export function filterNationalities(query: string): Nationality[] {
  const nq = norm(query.trim());
  if (!nq) return NATIONALITIES;
  return NATIONALITIES.filter(
    (n) => norm(n.adjective).includes(nq) || norm(n.country).includes(nq),
  );
}

/**
 * Dieselbe Liste, aber nach LAND gesucht (für das Land-Feld einer Anschrift).
 * Getrennt von {@link filterNationalities}, weil dort auch das Adjektiv matcht —
 * beim Land führt „deutsch" sonst zu Treffern, die als Ländername nichts taugen.
 */
export function filterCountries(query: string): Nationality[] {
  const nq = norm(query.trim());
  if (!nq) return NATIONALITIES;
  return NATIONALITIES.filter((n) => norm(n.country).includes(nq));
}
